import { Route, Routes } from 'react-router-dom';

import { BudgetProvider } from 'contexts';

import { DefaultLayout } from 'layouts/DefaultLayout';

import { Details } from './components/Details';
import { List } from './components/List';

export function BudgetsPage(): React.ReactElement {
  return (
    <DefaultLayout withHeader isNested>
      <Routes>
        <Route index element={<List />} />

        <Route
          path=":gender/:id"
          element={
            <BudgetProvider>
              <Details />
            </BudgetProvider>
          }
        />
      </Routes>
    </DefaultLayout>
  );
}
